import { createSlice } from '@reduxjs/toolkit';
import { userStorage } from 'local-storage/globle';

import {
  getProfileReducers,
  updateProfileReducers,
  changePasswordReducers,
  deleteUserReducers,
} from './users.reducers';

const initialState = {
  userId: '',
  user: {},
  getProfileStatus: '',
  updateProfileStatus: '',
  changePasswordStatus: '',
  deleteUserStatus: '',
  error: '',
};

const usersSlice = createSlice({
  name: 'user-slice',
  initialState,
  reducers: {
    setUser: (state) => {
      state.user = userStorage().get('user') ?? userStorage('session').get('user');
      state.userId = state.user._id;
    },
  },
  extraReducers: (builder) => {
    getProfileReducers(builder);
    updateProfileReducers(builder);
    changePasswordReducers(builder);
    deleteUserReducers(builder);
  },
});

export const { setUser } = usersSlice.actions;
export default usersSlice.reducer;